var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", attrs: { tag: "form" } },
    [
      _c(
        "div",
        [
          _c("h4", [_vm._v("Função por Equipe (Por Processo)")]),
          _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
            ? _c("app-modal-visualizar-completo", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  protocolo: _vm.protocolo,
                  numeroProcesso: _vm.numeroProcesso,
                  tipo: _vm.tipoProcesso
                },
                on: {
                  closeModal: function($event) {
                    _vm.showModalVisualizarProcesso = false
                  }
                }
              })
            : _vm._e(),
          _vm.grupos && Object.keys(_vm.grupos).length === 0
            ? _c("div", [
                _c("p", [_vm._v("Não há processos para serem exibidos")])
              ])
            : _c(
                "div",
                _vm._l(_vm.grupos, function(subProcessos, numeroDoProcesso) {
                  return _c(
                    "el-collapse",
                    {
                      key: numeroDoProcesso,
                      attrs: { accordion: true },
                      model: {
                        value: _vm.ativarTodas,
                        callback: function($$v) {
                          _vm.ativarTodas = $$v
                        },
                        expression: "ativarTodas"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          key: numeroDoProcesso,
                          attrs: { name: numeroDoProcesso }
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("span", { staticClass: "titulo" }, [
                              _vm._v(
                                "Processo " +
                                  _vm._s(numeroDoProcesso) +
                                  ": " +
                                  _vm._s(
                                    subProcessos[0]
                                      .nomeRazaoSocialInteressado ||
                                      subProcessos[0].processo
                                        .nomeRazaoSocialInteressado
                                  )
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            { attrs: { accordion: true } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-card",
                                    [
                                      _c(
                                        "el-col",
                                        { staticClass: "container-input" },
                                        [
                                          _c("validation-provider", {
                                            attrs: { rules: "required" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c("app-label", {
                                                        attrs: {
                                                          label:
                                                            "Vincular para: ",
                                                          required: true
                                                        }
                                                      }),
                                                      _c(
                                                        "el-radio-group",
                                                        {
                                                          class: {
                                                            "error-radio":
                                                              errors.length
                                                          },
                                                          attrs: {
                                                            disabled: _vm.isDisabledRadio(
                                                              subProcessos
                                                            )
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.setRadio(
                                                                $event,
                                                                numeroDoProcesso,
                                                                subProcessos
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.radio[
                                                                numeroDoProcesso
                                                              ],
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.radio,
                                                                numeroDoProcesso,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "radio[numeroDoProcesso]"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "FISCALIZADOR"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Fiscalizador"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "el-radio",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "GEOMENSOR"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Geomensor"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "help erro"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-row",
                                                        {
                                                          staticClass: "margin"
                                                        },
                                                        _vm._l(
                                                          subProcessos,
                                                          function(
                                                            subProcessoItem,
                                                            numeroSubProcesso
                                                          ) {
                                                            return _c(
                                                              "el-col",
                                                              {
                                                                key: numeroSubProcesso,
                                                                attrs: {
                                                                  span: 12
                                                                }
                                                              },
                                                              [
                                                                _vm.exibirSelectPorFuncao(
                                                                  subProcessoItem
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "validation-provider",
                                                                          {
                                                                            attrs: {
                                                                              rules: _vm.subProcessoFinalizado(
                                                                                subProcessoItem
                                                                              )
                                                                                ? ""
                                                                                : "required"
                                                                            },
                                                                            scopedSlots: _vm._u(
                                                                              [
                                                                                {
                                                                                  key:
                                                                                    "default",
                                                                                  fn: function(
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "app-label",
                                                                                        {
                                                                                          attrs: {
                                                                                            label: _vm.getFuncao(
                                                                                              subProcessoItem.funcao
                                                                                            ),
                                                                                            required: !_vm.subProcessoFinalizado(
                                                                                              subProcessoItem
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "el-select",
                                                                                        {
                                                                                          staticClass:
                                                                                            "input seletor",
                                                                                          attrs: {
                                                                                            value: _vm.getUsuario(
                                                                                              subProcessoItem
                                                                                                .usuario
                                                                                                .id
                                                                                            ),
                                                                                            disabled: _vm.subProcessoFinalizado(
                                                                                              subProcessoItem
                                                                                            )
                                                                                          },
                                                                                          on: {
                                                                                            input: function(
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.setUsuario(
                                                                                                subProcessoItem,
                                                                                                $event
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        _vm._l(
                                                                                          _vm.analistasSelecionados,
                                                                                          function(
                                                                                            usuario
                                                                                          ) {
                                                                                            return _c(
                                                                                              "el-option",
                                                                                              {
                                                                                                key:
                                                                                                  usuario.id,
                                                                                                attrs: {
                                                                                                  label:
                                                                                                    usuario.nome,
                                                                                                  value:
                                                                                                    usuario.id
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          }
                                                                                        ),
                                                                                        1
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "help erro"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              errors[0]
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  }
                                                                                }
                                                                              ],
                                                                              null,
                                                                              true
                                                                            )
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "button-visualizar"
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.visualizarProcesso(
                                                        subProcessos[0]
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-eye"
                                                  }),
                                                  _vm._v(
                                                    "  Visualizar Processo"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5adfbb54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adfbb54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ordemServico/DadosEquipe.vue
// module id = null
// module chunks = 